import { FormikProps, withFormik } from 'formik'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { Body1 } from '@ui/Typography'

import { FormSubmitValues } from '@utils/formValidation'

import { createFormCheckBoxField } from '@global/formField/FormCheckBoxField'

import { Box } from '@shared/components/Box'

export interface ChangeEmailFormValues {
  newsletterChoice: boolean
}

const FormCheckBoxField = createFormCheckBoxField<ChangeEmailFormValues>()

const ChangeEmailFormUI: React.FC<FormikProps<ChangeEmailFormValues> & OuterProps> = (props) => {
  const { handleSubmit, setSubmitting, setFieldValue, isSubmitting } = props
  const { t } = useTranslation()

  return (
    <div>
      <Box flex justify='space-between' align='center' gap='x4'>
        <Body1 className='field'>{t("Profile.Register to Tickmill's newsletters")}</Body1>
        <FormCheckBoxField
          onChange={(v) => {
            setFieldValue('newsletterChoice', v)
            setSubmitting(true)
            handleSubmit()
          }}
          disabled={isSubmitting}
          name='newsletterChoice'
        />
      </Box>
    </div>
  )
}

interface OuterProps {
  newsletterChoice?: boolean

  onSubmit(values: FormSubmitValues<ChangeEmailFormValues>): Promise<void>
}

export const ChangeEmailForm = withFormik<OuterProps, ChangeEmailFormValues>({
  mapPropsToValues: ({ newsletterChoice = false }) => {
    return {
      newsletterChoice,
    }
  },
  handleSubmit: async (values, { props, setSubmitting }) => {
    try {
      await props.onSubmit(values)
    } finally {
      setSubmitting(false)
    }
  },
  enableReinitialize: true,
})(ChangeEmailFormUI)
